/** @jsx jsx */
import { jsx, css } from "@emotion/core"
import { useLoginLogout } from "../hooks"
import { Fragment } from "react"
import Button from "../UI/Button/Button"
import ExitToAppIcon from "@material-ui/icons/ExitToApp"
import { defaultThemeValues } from "../styles"

function LoginLogout() {
    const { handler, isAuthenticated } = useLoginLogout()

    return (
        <Fragment>
            {(isAuthenticated && (
                <Button
                    color="secondary"
                    onClick={handler}
                    rootStyles={styles.root}
                    startIcon={<ExitToAppIcon />}
                >
                    {""}
                </Button>
            )) ||
                null}
        </Fragment>
    )
}

export default LoginLogout

const styles = {
    root: css`
        position: absolute;
        top: 0;
        right: 0;
        z-index: 120;
        ${defaultThemeValues.mediaQuery.desktop.default} {
            position: fixed;
        }
    `,
}

// Kinyomopisztolyok, szalagok - uj kategria

// Kisker , felhasznalo az akcios doboznak - ugyfeleknek adni. Minding dobja fel a docyt
